export default __webpack_public_path__ + "static/media/self2.ff5f318d.png";